import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { NavLink } from 'react-router-dom';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IGruppoListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPagineGruppo;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class GruppoLista extends BaseComponent<Glob.IRouteGlobaleProps, IGruppoListaState> {

    private ParametriFissi: Dati.TListaParametri = {};

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 100;
        Param.Pagina = 1;
        this.state = { Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreLista = this.OnErroreLista.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        //Con il bind si può scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [2], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_Gruppo", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("Gruppo", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }

    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPagineGruppo, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
            let menu = 32;

            var M = Glob.GetMenu();
            M.Main = "Utente";
            M.ID_MenuMain = menu;
            this.props.SetMenu(M);
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={3} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr data-row="0" key={dato.ID_Gruppo}>
                        <td data-field="ID" className="TextCenter"> <a href="#" className="arrow" onClick={(e) => { e.preventDefault(); this.props.history.push("/Gruppo/" + dato.ID_Gruppo) }}>
                            {dato.ID_Gruppo}
                        </a>
                        </td>
                        <td data-field="RagioneSociale" className="TextLeft">{dato.Gruppo}</td>
                        <td data-field="edit" className="TextCenter">
                            <a href="#" className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" onClick={(e) => { e.preventDefault(); this.props.history.push("/Gruppo/" + dato.ID_Gruppo) }}>
                                <i className="la la-edit"></i>
                            </a>
                        </td>
                    </tr>
                )}
            </tbody>;
        }
        //<div className="divtabella"><ChiamaAPI URL="/api/ControlloLimiti" /></div>
    }

    private OnErroreLista(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={3}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public render() {
        if (!this.ControlloAutorizzazione("GruppoController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-users"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Gruppi")}</h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura} aria-expanded="true">
                            <NavLink to="/Utente/0" className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                <i className="fa fa-plus"></i>
                            </NavLink>
                        </div>
                    </ul>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("ID")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["ID_Gruppo"] || ""} name="ParametriUtente[ID_Gruppo]" className="form-control kt-input" placeholder={Trad.Trad("ID")} />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Nome")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["Gruppo"] || ""} name="ParametriUtente[Gruppo]" className="form-control kt-input" placeholder={Trad.Trad("Gruppo")} />
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                        <div className="row">
                            <div className="col-12 kt-form__actions kt-form__actions--center">
                                <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
            <div>
                <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                    <thead>
                        <tr className="sfondoTab">
                            <th data-field="ID" scope="row" className="TextCenter">ID</th>
                            <th data-field="Nome" scope="row" className="TextLeft">{Trad.Trad("Nome")}</th>
                            <th data-field="edit" className="TextCenter">{Trad.Trad("Modifica")}</th>
                        </tr>
                    </thead>
                    <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/Gruppo/Ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreLista} />
                </table>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/GruppoLista.tsx